// Route/section guard for *authorization* (you're logged in, but do you
// have the role?). Pair with <RequireAuth> which handles *authentication*.
//
//   <RequireAuth><RequireAccess permission="admin:config"><Page/></RequireAccess></RequireAuth>

import { useCan, type Permission } from "./roles";

export function RequireAccess({
  permission,
  children,
  fallback,
}: {
  permission: Permission;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const allowed = useCan(permission);
  if (allowed) return <>{children}</>;
  return (
    <>
      {fallback ?? (
        <div className="mx-auto max-w-md py-16 text-center">
          <h2 className="text-lg font-semibold">No access</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Your account doesn’t have permission to view this. Ask an admin if you think that’s wrong.
          </p>
        </div>
      )}
    </>
  );
}
